<template>
	<div>
		<label>
			<strong :class="{required: !item.allowNull}">{{item.text}}</strong>
		</label>
		<div>
			<input
				type="number"
				:value="item.value"
				v-if="numberTypes.includes(item.type) && !hasAvailableValues(item)"
				class="form-control"
				@change="onChange"
				:readonly="readonly"
			/>
			<DateTimePicker
				v-if="item.type == 'System.DateTime'"
				:value="item.value"
				@change="onChange"
				:showTime="false"
				:readonly="readonly"
				:bindPopup="bindPopup"
				:popupContainerId="popupContainerId"
			></DateTimePicker>
			<input
				type="string"
				:value="item.value"
				v-if="textTypes.includes(item.type) && !hasAvailableValues(item)"
				class="form-control"
				@change="onChange"
				:readonly="readonly"
			/>
			<Dropdown
                v-if="hasAvailableValues(item) && !item.multivalue"
                :value="item.value"
                :items="dropdownItems"
                :disabled="readonly"
				:bindPopup="bindPopup"
				:popupContainerId="popupContainerId"
                @input="onChange"
            >
            </Dropdown>

			<MultiSelect
                v-if="hasAvailableValues(item) && item.multivalue"
                :value="item.value"
                :items="dropdownItems"
                :disabled="readonly"
				:bindPopup="bindPopup"
				:popupContainerId="popupContainerId"
                @input="onChange"
            >
            </MultiSelect>
		</div>
		<div v-if="!item.allowNull && !item.value" class="text-danger">{{$t('validation.requiredField')}}</div>
	</div>
</template>

<script>
import Dropdown from '../dropdown/StaticDropdown';
import MultiSelect from '../dropdown/StaticMultiSelect';
import DateTimePicker from '../datepicker/DateTimePicker';
export default {
	components: {
		Dropdown,
		DateTimePicker,
		MultiSelect
	},
	props: {
		item: {
			type: Object,
			required: true
		},
		bindPopup: {
			type: Boolean,
			default: false
		},
		popupContainerId: {
			type: String,
			default: ""
		},
		readonly: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			types: ['System.DateTime', 'System.Int64', 'System.Int32', 'System.Decimal', 'System.Double', 'System.Guid', 'System.Boolean', 'System.String'],
			numberTypes: ['System.Int64', 'System.Int32', 'System.Decimal', 'System.Double'],
			textTypes: ['System.Guid', 'System.String']

		};
	},
	methods: {
		onChange(val) {
			if (val instanceof Event) {
				this.item.value = val.target.value;
			} else {
				this.item.value = val;
			}

			if (this.item.childParameters && this.item.childParameters.length) {
				this.$emit('loadChild', this.item);
			}
		},
		hasAvailableValues(item) {
			return item.availableValues && item.availableValues.length;
		}
	},
	computed: {
		dropdownItems() {
			return this.item.availableValues.map(x => ({ id: x.value, text: x.name }));
		}
	}
};
</script>

<style>
</style>
